<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <g fill="none" fill-rule="evenodd">
            <circle cx="8" cy="8" r="8" fill="#DA4E4E"/>
            <path fill="#FFF" fill-rule="nonzero" d="M8.576 9.962l.28-6.3H6.714l.294 6.3h1.568zm-.784 3.178c.616 0 1.134-.518 1.134-1.12 0-.616-.518-1.134-1.134-1.134-.616 0-1.12.518-1.12 1.134 0 .602.504 1.12 1.12 1.12z"/>
        </g>
    </svg>
</template>
<script>
export default { name: 'danger-icon' }
</script>
